import {
  BulkSessionSummaryResponse,
  BulkSummary,
  CannedPrompt,
  SessionSummaryResponse,
} from '@fullstory/proto/fs/services/llm-tool';
import { mockSessionSummaryResponse as createMockSessionSummary } from './utils';

export const mockSessionSummaryResponseObj: SessionSummaryResponse = createMockSessionSummary({});

const mockBulkSummary: BulkSummary = {
  summary: 'Test bulk summary',
  prompt: { cannedPrompt: CannedPrompt.USER_LINKS },
};

const mockTagSummary: BulkSummary = {
  summary: 'tag1,tag2,tag3',
  prompt: { cannedPrompt: CannedPrompt.TAGS },
};

export const mockBulkSessionSummaryResponse: BulkSessionSummaryResponse = {
  summaries: [mockBulkSummary, mockTagSummary],
  baseSummaries: [{ summary: 'Test base summary', session: null }],
};
